/* eslint-disable func-names */
import $ from "jquery";

const accordion = () => {
  $('.js-accordion').on('click', function(){
    const $this = $(this);
    const $content = $this.next();

    $content.slideToggle();

    // data-open属性の付与・削除
    if ($this.attr('data-open') !== undefined) {
      $this.removeAttr('data-open');
      $content.removeAttr('data-open');
    } else {
      $this.attr('data-open', '');
      $content.attr('data-open', '');
    }
  });
};

const main = () => {
  accordion();
};

export default main;
